import * as _ from "lodash";
import PropTypes from "prop-types";

/**
 * Flat list of selectable options with icons.
 *
 * @param root0 - The component props.
 * @param root0.options - The array of selectable options.
 * @param root0.title - The list title.
 * @param root0.disabled - Whether the list is disabled.
 * @param root0.className - Additional CSS class name.
 * @param root0.onSelect - The selection change handler.
 * @returns The rendered multi-select component.
 */
const FlatMultiSelect = ({
    options,
    title,
    disabled,
    className = "",
    onSelect,
}) => {
    const renderTitle = () => {
        return title && <div className="flat-multi-select-title">{title}</div>;
    };

    const renderOption = (option) => {
        const classNames = [];
        if (disabled) {
            classNames.push("disabled");
        }
        return (
            <div
                key={`option-${option.key}`}
                className={`flat-multi-select-option ${classNames.join(" ")}`}
                onClick={() => onSelect(option.value)}
            >
                {option.icon && (
                    <div className="flat-multi-select-option-icon">
                        {option.icon}
                    </div>
                )}
                <div
                    className="flat-multi-select-option-description"
                    style={{ color: option.color }}
                >
                    {option.key}
                </div>
                {option.selected && (
                    <div className="flat-multi-select-option-selected-indicator">
                        <i className="fas fa-check" />
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className={`flat-multi-select ${className}`}>
            {renderTitle()}
            <div
                className={`flat-multi-select-options ${disabled ? "disabled" : ""}`}
            >
                {_.map(options, renderOption)}
            </div>
        </div>
    );
};

FlatMultiSelect.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any,
            key: PropTypes.string,
            selected: PropTypes.bool,
            icon: PropTypes.node,
        }),
    ),
    title: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onSelect: PropTypes.func,
};

export default FlatMultiSelect;
